import { render, staticRenderFns } from "./WithdrawNote.vue?vue&type=template&id=629f40f1"
import script from "./WithdrawNote.vue?vue&type=script&lang=js"
export * from "./WithdrawNote.vue?vue&type=script&lang=js"
import style0 from "./WithdrawNote.vue?vue&type=style&index=0&id=629f40f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports